import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pxaznsy3qa: FaireBrandEntity = {
  token: "b_pxaznsy3qa",
  type: "brand",
  name: "Toffee Traditions",
  avatarUrl:
    "https://cdn.faire.com/fastly/651d2b9461659976bd18c0e31a0c4c400eb6cb447aaedb289c12057e5e801715.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/404484b77270e131fbe6f2ae63c6bea3613d0865dafcc5b6a09cf21f158154e6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/651d2b9461659976bd18c0e31a0c4c400eb6cb447aaedb289c12057e5e801715.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/404484b77270e131fbe6f2ae63c6bea3613d0865dafcc5b6a09cf21f158154e6.jpeg",
  location: "Highwood, IL, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "At Toffee Traditions, we pride ourselves on crafting exquisite confections that celebrate the timeless allure of English toffee. Rooted in artisanal tradition and a commitment to quality, we meticulously handcraft each batch of our toffee using only the finest ingredients.\nWhat sets Toffee Traditions apart is our dedication to innovation, infusing classic toffee with unique flavors that tantalize the taste buds and elevate the experience of indulgence. From rich dark chocolate to zesty citrus twists, our diverse range of flavors ensures there's something to delight every palate.\nAs a small-batch, boutique confectionary, we prioritize quality over quantity, ensuring that every piece of toffee that leaves our kitchen embodies the essence of luxury and craftsmanship. Whether it's a treat for yourself or a gift for someone special, Toffee Traditions offers a truly decadent experience that transcends the ordinary.\nIndulge in the artistry of fine confections with Toffee Traditions, where each bite is a celebration of tradition, flavor, and the pursuit of sweetness.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:53.901Z",
    importedBy: "entity-db-cli",
  },
};
